<template>
  <MainLayout page-name="index">
    <div class="index">Please select a menu</div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'

export default {
  components: {
    MainLayout
  }
}
</script>
<style lang="scss" scoped>
  .index {
    font-size: 2.5em;
    font-style: oblique;
    color: #d7d7d7;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 500px;
  }
</style>
